import React, { useEffect, useState } from 'react'
import './Subscribe.css'

const Subscribe = () => {
  const [voteData, setVoteData] = useState({
    country: 'India',
    state: 'Punjab',
    city: 'Ludhiana'
  })
  
  const [email, setEmail] = useState('')
  const [countries, setCountries] = useState([])
  const [states, setStates] = useState([])
  const [cities, setCities] = useState([])

  useEffect(() => {
    const fetchCountries = async () => {
      try {
        const response = await fetch('https://api-csc.indraq.info/api/countries')
        const data = await response.json()
        const list = Array.isArray(data) ? data : (Array.isArray(data?.data) ? data.data : [])
        setCountries(list)
        if (list.length && !voteData.country) {
          setVoteData((prev) => ({ ...prev, country: list[0]?.name || '' }))
        }
      } catch (error) {
        console.error('Failed to load countries', error)
      }
    }

    fetchCountries()
  }, [voteData.country])

  useEffect(() => {
    if (!voteData.country) {
      setStates([])
      setCities([])
      return
    }

    const fetchStates = async () => {
      try {
        const response = await fetch(`https://api-csc.indraq.info/api/states?country_name=${encodeURIComponent(voteData.country)}`)
        const data = await response.json()
        const list = Array.isArray(data) ? data : (Array.isArray(data?.data) ? data.data : [])
        setStates(list)
        if (list.length) {
          setVoteData((prev) => ({
            ...prev,
            state: list.find((item) => item.name === prev.state)?.name || list[0]?.name || '',
            city: ''
          }))
        } else {
          setVoteData((prev) => ({ ...prev, state: '', city: '' }))
        }
      } catch (error) {
        console.error('Failed to load states', error)
      }
    }

    fetchStates()
  }, [voteData.country])

  useEffect(() => {
    if (!voteData.country || !voteData.state) {
      setCities([])
      return
    }

    const fetchCities = async () => {
      try {
        const response = await fetch(
          `https://api-csc.indraq.info/api/cities?country_name=${encodeURIComponent(voteData.country)}&state_name=${encodeURIComponent(voteData.state)}`
        )
        const data = await response.json()
        const list = Array.isArray(data) ? data : (Array.isArray(data?.data) ? data.data : [])
        setCities(list)
        if (list.length) {
          setVoteData((prev) => ({
            ...prev,
            city: list.find((item) => item.name === prev.city)?.name || list[0]?.name || ''
          }))
        } else {
          setVoteData((prev) => ({ ...prev, city: '' }))
        }
      } catch (error) {
        console.error('Failed to load cities', error)
      }
    }

    fetchCities()
  }, [voteData.country, voteData.state])

  const handleVoteSubmit = (e) => {
    e.preventDefault()
    console.log('Vote submitted:', voteData)
    // Add your vote submission logic here
  }

  const handleSubscribe = (e) => {
    e.preventDefault()
    console.log('Subscribed:', email)
    // Add your subscription logic here
  }

  return (
    <div className="subscribe-container">
      <div className="subscribe-card">
        <div className="subscribe-content">
          {/* Left Section - Vote */}
          <div className="vote-section">
            <h2>Want Mulaqaat in your city</h2>
            <h2>Vote Now</h2>
            <form onSubmit={handleVoteSubmit} className="vote-form">
              <select 
                value={voteData.country}
                onChange={(e) => setVoteData({...voteData, country: e.target.value})}
                className="vote-select"
              >
                {countries.map((country) => (
                  <option key={country.id || country.name} value={country.name}>
                    {country.name}
                  </option>
                ))}
              </select>
              
              <select 
                value={voteData.state}
                onChange={(e) => setVoteData({...voteData, state: e.target.value})}
                className="vote-select"
              >
                {states.map((state) => (
                  <option key={state.id || state.name} value={state.name}>
                    {state.name}
                  </option>
                ))}
              </select>
              
              <select 
                value={voteData.city}
                onChange={(e) => setVoteData({...voteData, city: e.target.value})}
                className="vote-select"
              >
                {cities.map((city) => (
                  <option key={city.id || city.name} value={city.name}>
                    {city.name}
                  </option>
                ))}
              </select>
              
              <button type="submit" className="vote-button">Vote for Your City</button>
            </form>
          </div>

          {/* Center Section - Illustration */}
          <div className="illustration-section">
            <img
              src="/Subscribe.webp"
              alt="Couple illustration"
              className="couple-illustration"
            />
          </div>

          {/* Right Section - Subscribe */}
          <div className="subscribe-section">
            <h2>Subscribe to updates from</h2>
            <h2>The Event House</h2>
            <form onSubmit={handleSubscribe}>
              <input 
                type="email" 
                placeholder="harkaran@indraq.com"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                className="email-input"
                required
              />
              <button type="submit" className="subscribe-button">Submit</button>
            </form>
          </div>
        </div>
      </div>
    </div>
  )
}

export default Subscribe
